module.exports = __webpack_public_path__ + "static/media/13ITC2.9335d2e9.jpg";